/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const MenuIcon = ({
  className,
  style,
  color = '#2F54EB',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.78 19H1.22C1.099 19 1 19.09 1 19.2V20.8C1 20.91 1.099 21 1.22 21H22.78C22.901 21 23 20.91 23 20.8V19.2C23 19.09 22.901 19 22.78 19Z"
        fill={color}
      />
      <path
        d="M16.7647 11H1.23529C1.10588 11 1 11.09 1 11.2V12.8C1 12.91 1.10588 13 1.23529 13H16.7647C16.8941 13 17 12.91 17 12.8V11.2C17 11.09 16.8941 11 16.7647 11Z"
        fill={color}
      />
      <path
        d="M22.78 3H1.22C1.099 3 1 3.09 1 3.2V4.8C1 4.91 1.099 5 1.22 5H22.78C22.901 5 23 4.91 23 4.8V3.2C23 3.09 22.901 3 22.78 3Z"
        fill={color}
      />
    </svg>
  );
};
